/**
 * @generated SignedSource<<a112de08e9e89975db57e6538de7d055>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Sidebar_employee$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CallWidgetHost_employee" | "TimeTrackWidget_employee">;
  readonly " $fragmentType": "Sidebar_employee";
};
export type Sidebar_employee$key = {
  readonly " $data"?: Sidebar_employee$data;
  readonly " $fragmentSpreads": FragmentRefs<"Sidebar_employee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Sidebar_employee",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeTrackWidget_employee"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CallWidgetHost_employee"
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "2824fe4534bbf4a9fb29b0ebd1f5d592";

export default node;
